import {
  type Layer,
  type StandardChartLayerSpec,
  defineStandardChartLayer
} from '../../../core/layer';
import DEFINE from '../../../util/DEFINE';

const visInfo: Layer['visInfo'] = {
  id: 'doublePie',
  name_en: 'Double Pie',
  name_zh: '双饼图',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  rules: {
    data: amount => amount < 15,
    x: amount => amount > 1,
    x2: amount => amount > 1
  },
  /** 保证和 Spec.encoding 字段一致 */
  parameters: {
    x: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE
    },
    y: { itemType: [DEFINE.NUMBER], category: DEFINE.SINGLE },
    x2: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE
    },
    y2: { itemType: [DEFINE.NUMBER], category: DEFINE.SINGLE }
  }
};

export interface Spec extends StandardChartLayerSpec {
  encoding: {
    x: string;
    y: string;
    x2: string;
    y2: string;
  };
}

export const layer = defineStandardChartLayer<Spec>({
  type: visInfo.id,
  isIndependentLayer: true,
  visInfo,
  render(api, spec) {
    const { layout, data: dataArray, util, hook } = api;
    const {
      dataIndex = 0,
      encoding: { x, y: tempY, x2, y2: tempY2 }
    } = spec;
    // 兜底数组情况，饼图y字段默认不支持数组
    const y = (Array.isArray(tempY) ? tempY[0] : tempY) as string;
    const y2 = (Array.isArray(tempY2) ? tempY2[0] : tempY2) as string;

    // * -------------------------- data
    const data = dataArray[dataIndex];
    const dataMetaInfo = api.hook.parseDataMetaInfo(data);
    const series0Data = data.values.map(item => ({
      name: item[x],
      value: +item[y]
    }));
    const series1Data = data.values.map(item => ({
      name: item[x2],
      value: +item[y2]
    }));

    // * -------------------------- chart
    const showLabel = ![util.const.LAYOUT.SMALL, util.const.LAYOUT.SMALL_1_2].includes(layout);

    return {
      tooltip: {
        formatter: params => {
          const series = Array.isArray(params) ? params : [params];
          const items = [];

          series.forEach(item => {
            const result = hook.formatDataNumberValue(item.value, {
              type: 'table',
              unit: dataMetaInfo[item.seriesName]?.unit
            });

            items.push({
              type: util.const.SERIES_2_LEGEND_TYPE_MAP[
                item.seriesType as keyof (typeof util)['const']['SERIES_2_LEGEND_TYPE_MAP']
              ],
              color: item.color,
              name: item.name,
              value: result.value + result.unit
            });
          });

          return hook.buildTooltip({
            config: hook.buildStandardChartPresetOption(api).tooltip,
            title: series?.[0]?.seriesName,
            items
          });
        }
      },
      xAxis: [],
      yAxis: [],
      series: [
        {
          name: y,
          type: 'pie',
          selectedMode: 'single',
          radius: showLabel ? [0, '50%'] : [0, '60%'],
          label: {
            position: 'inner'
          },
          data: series0Data
        },
        {
          name: y2,
          type: 'pie',
          radius: showLabel ? ['65%', '80%'] : ['75%', '95%'],
          label: {
            show: showLabel
          },
          data: series1Data
        }
      ]
    };
  }
});
